import * as React from "react"

import Logo from './components/Logo'
import ContactCard from './components/ContactCard'
import MobileNav from './components/MobileNav'

// @ts-ignore
import styles from './TopBar.module.scss'

export function TopBar({slogan, LinkComponent}) {
  return(
    <div className={styles.TopBar}>
      <div className={styles.contentContainer}>
        <Logo LinkComponent={LinkComponent}/>
        <div className={styles.cardAndNavContainer}>
          <ContactCard mobileNav={false}/>

          <MobileNav LinkComponent={LinkComponent}/>
        </div>
      </div>
      {slogan &&
      <div className={styles.slogan}>
        snabbt, tryggt och enkelt!
      </div>
      }
    </div>
  )
}
